"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConfigValue = void 0;
var tslib_1 = require("tslib");
function resolveConfigValue(value) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (typeof value === 'function') {
                // eslint-disable-next-line @typescript-eslint/ban-types
                return [2 /*return*/, value()];
            }
            return [2 /*return*/, value];
        });
    });
}
exports.resolveConfigValue = resolveConfigValue;
//# sourceMappingURL=resolveConfigValue.js.map